import React from 'react';
import { Box, SwipeableDrawer } from '@mui/material';
import colors from '../../../assets/theme/colors';
import { ChildSwitcherPanel } from '../shared/ChildSwitcher';
import ChildActionsMenuContent from '../shared/ChildActionsMenuContent';

const DrawerHandle = () => (
  <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
    <Box
      sx={{
        width: 36,
        height: 4,
        borderRadius: 9999,
        bgcolor: colors.landing.borderLight,
      }}
    />
  </Box>
);

const MobileChildSheets = ({
  actionsOpen,
  onActionsOpen,
  onActionsClose,
  switchOpen,
  onSwitchOpen,
  onSwitchClose,
  activeChild,
  activeChildRole,
  activeChildCareTeam,
  children,
  getUserRoleForChild,
  careTeamsByChildId,
  setActiveChildId,
  onGoToCareTeam,
  onEditChild,
  onInviteTeamMember,
  onDeleteChild,
  onDailyReport,
  onImportLogs,
  onOpenBathroomLog,
  onOpenSleepLog,
  onAddChildClick,
}) => (
  <>
    <SwipeableDrawer
      anchor="bottom"
      open={actionsOpen}
      onOpen={onActionsOpen}
      onClose={onActionsClose}
      disableBackdropTransition
      disableDiscovery
      PaperProps={{
        sx: {
          height: '82vh',
          borderRadius: '20px 20px 0 0',
          bgcolor: colors.landing.surface,
          borderTop: `1px solid ${colors.landing.borderLight}`,
          boxShadow: `0 -18px 48px ${colors.landing.shadowPanel}`,
          maxHeight: '82vh',
          display: 'flex',
          flexDirection: 'column',
          pb: 'env(safe-area-inset-bottom)',
          overflow: 'hidden',
        },
      }}
    >
      <Box sx={{ px: 1.5, pt: 0.75, pb: 1.5, height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        <DrawerHandle />

        <ChildActionsMenuContent
          child={activeChild}
          userRole={activeChildRole}
          careTeamCount={activeChildCareTeam.length}
          showPrepForTherapy={false}
          showImportLogs={false}
          onGoToCareTeam={(child) => {
            onActionsClose();
            onGoToCareTeam?.(child);
          }}
          onEditChild={(child) => {
            onActionsClose();
            onEditChild?.(child);
          }}
          onInviteTeamMember={(childId) => {
            onActionsClose();
            onInviteTeamMember?.(childId);
          }}
          onDeleteChild={(child) => {
            onActionsClose();
            onDeleteChild?.(child);
          }}
          onPrepForTherapy={(child) => {
            onActionsClose();
            onDailyReport?.(child);
          }}
          onImportLogs={(child) => {
            onActionsClose();
            onImportLogs?.(child);
          }}
          onOpenBathroomLog={(child) => {
            onActionsClose();
            onOpenBathroomLog?.(child);
          }}
          onOpenSleepLog={(child, entry = null, options = {}) => {
            onActionsClose();
            onOpenSleepLog?.(child, entry, options);
          }}
        />
      </Box>
    </SwipeableDrawer>

    <SwipeableDrawer
      anchor="bottom"
      open={switchOpen}
      onOpen={onSwitchOpen}
      onClose={onSwitchClose}
      disableBackdropTransition
      disableDiscovery
      PaperProps={{
        sx: {
          borderRadius: '20px 20px 0 0',
          bgcolor: colors.landing.surface,
          borderTop: `1px solid ${colors.landing.borderLight}`,
          boxShadow: `0 -18px 48px ${colors.landing.shadowPanel}`,
          height: 'auto',
          maxHeight: '90dvh',
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          px: 1.5,
          pt: 0.75,
          pb: 1.5,
        }}
      >
        <DrawerHandle />

        <ChildSwitcherPanel
          children={children}
          activeChildId={activeChild?.id}
          getUserRoleForChild={getUserRoleForChild}
          careTeamsByChildId={careTeamsByChildId}
          onSelectChild={(childId) => {
            setActiveChildId?.(childId);
            onSwitchClose();
          }}
          onAddChild={() => {
            onSwitchClose();
            onAddChildClick?.();
          }}
          showCareTeamSummary
          showAddChild={Boolean(onAddChildClick)}
          activeChild={activeChild}
          stickyAddChild
          showAddChildFooter={false}
        />
      </Box>
    </SwipeableDrawer>
  </>
);

export default MobileChildSheets;
